import * as yaml from 'js-yaml'

import type { Survey } from '#survey/schemas/survey'
import topicSchema from '#survey/schemas/topic'

// Quest templates are bundled as the topics of a synthetic 'quests' Survey so
// they flow through SurveyCollection and buildFinancialRecords unchanged.
// Because a quest is structurally a Topic, we validate each YAML entry with
// the shared topicSchema — that gives us subtopics, per-topic unique-id
// refines, and subtopicId targeting for free.
const parseQuestTemplates = (rawFiles: string[]): Survey => ({
  id: 'quests',
  title: 'Quests',
  icon: '🏆',
  subtitle: null,
  description: null,
  topics: rawFiles.map(raw => {
    const parsed = yaml.load(raw)
    const { success, data, error } = topicSchema.safeParse(parsed)
    if (!success)
      throw new Error(error.issues[0]?.message ?? 'Invalid quest YAML')
    return data
  }),
})

export default parseQuestTemplates
